export interface WithOrigin {
  id: number
  originId?: number | null
}

/** Живая идентичность урока/блока: id оригинала у черновика, иначе собственный id. */
export const liveIdentity = (e: WithOrigin): number => e.originId ?? e.id

/** id той же сущности в новом списке; null — её там нет (удалена, отменена). */
export const remapId = (
  id: number | null,
  prev: readonly WithOrigin[],
  next: readonly WithOrigin[],
): number | null => {
  if (id === null) return null
  const was = prev.find((e) => e.id === id)
  const key = was ? liveIdentity(was) : id
  return next.find((e) => liveIdentity(e) === key)?.id ?? null
}
